import { makeStyles } from "@mui/styles";

const useStyles = makeStyles(() => ({
  wrapper: {
    position: "relative",
    display: "-webkit-box",
    overflow: "hidden",
    textOverflow: "ellipsis",
    "-webkit-box-orient": "vertical",
    "-moz-box-orient": "vertical",
    lineHeight: "normal",
  },
  button: {
    cursor: "pointer",
    border: 0,
  },
  expandButton: {
    position: "absolute",
    bottom: 0,
    right: 0,
  },
}));

export default useStyles;
